<template>
  <emd-modal scrollable has-header has-footer footer-buttons-on-right :open="isOpen" @close="close">
    <template v-slot:header>
      <h2 class="emd-text _size_section _color_secondary">
        {{ title || $t('DEFAULT-TITLE') }}
      </h2>
    </template>
    <template v-slot:content>
      <h2 class="emd-text _size_section _color_contrast">
        {{ message }}
      </h2>
    </template>
    <template v-slot:footer>
      <div class="_footer_end">
        <button @click="confirmModal(false)" class="emd-btn _color_primary _type_text" type="button">
          {{ $t('CANCEL') }}
        </button>
        <button @click="confirmModal(true)" class="emd-btn _color_primary" type="submit">
          {{ $t('CONFIRM') }}
        </button>
      </div>
    </template>
  </emd-modal>
</template>
<script>
import { EmdModal } from '../../../index'

export default {
  name: 'EmdConfirm',
  components: { EmdModal },
  props: {
    title: {
      type: String,
      required: false
    },
    message: {
      type: String,
      required: true
    },
    isOpened: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      isOpen: this.isOpened
    }
  },
  methods: {
    open () { this.isOpen = true },
    close () { this.isOpen = false },
    confirmModal (val) {
      this.close()
      this.$emit('confirm', val)
    }
  }
}
</script>
<i18n>
{
  "pt-BR": {
    "CONFIRM": "Confirmar",
    "CANCEL": "Cancelar",
    "DEFAULT-TITLE": "Confirmar ação"
  },
  "en-US": {
   "CONFIRM": "Confirm",
   "CANCEL": "Cancel",
   "DEFAULT-TITLE": "Confirm action"
  }
}
</i18n>
